import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './GenderValidation';

import NavLinks from '../../NavLinks';

import useOmrData from '../../state/omr/UseOmrData';

import useCompetitionGenderTypeData from '@usas/ui-web/state/competitionGender/UseCompetitionGenderTypeData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

import useDidMountEffect from '@usas/ui-web/utils/UseDidMountEffect';
import Constants from '@usas/ui-web/utils/Constants';
import useForm from '@usas/ui-web/utils/UseForm';

const UNKNOWN_COMPETITION_GENDER_TYPE_NAME = 'Unknown';

const INITIAL_FORM_STATE = {
  competitionGenderTypeId: Constants.DEFAULT_ID,
  competitionGenderTypeDisplayName: '',
  competitionGenderTypeName: ''
}

const INITIAL_VIEW_STATE = {
  isCompetitionCategoryLocked: false,
}

const useCompetitonCategoryAthU16 = () => {
  const navigate = useNavigate();
  const { personState, savePersonState, isSaved } = useOmrData();
  const { competitionGenderState } = useCompetitionGenderTypeData();
  const [state, setState] = useState(INITIAL_VIEW_STATE);
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const { UNKNOWN_COMPETITION_GENDER_ID } = useEnvironmentVariableData();
  const {
    formState,
    errorState,
    setFormData,
    handleSubmit,
    onFormValueChanged } = useForm(INITIAL_FORM_STATE, submitFormCallback, validate);

  function submitFormCallback(formState) {

    const newPerson = {
      ...personState,
      person: {
        ...personState.person,
        competitionGenderTypeId: formState.competitionGenderTypeId
      }
    };

    savePersonState(newPerson);
  };

  useEffect(() => {
    if (personState?.person?.personId !== '' && personState?.person?.competitionGenderTypeId > 0
      && personState?.person?.competitionGenderTypeName !== '' && personState?.person?.competitionGenderTypeId !== UNKNOWN_COMPETITION_GENDER_ID
      && personState?.person?.competitionGenderTypeName !== UNKNOWN_COMPETITION_GENDER_TYPE_NAME) {

      setState({ ...state, isCompetitionCategoryLocked: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personState?.person.personId, personState.person.competitionGenderTypeName]);

  useEffect(() => {
    if (state?.isCompetitionCategoryLocked === true) {
      const newFormState = {
        ...formState,
        competitionGenderTypeName: personState?.person?.competitionGenderTypeName,
        competitionGenderTypeId: personState?.person?.competitionGenderTypeId
      };

      setFormData(newFormState, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isCompetitionCategoryLocked]);

  useEffect(() => {
    if (personState && Object.keys(personState).length > 0) {
      if (personState.person.competitionGenderTypeId > 0) {
        if (formState.competitionGenderTypeId !== Constants.DEFAULT_ID && isSaved === false) {
          if (formState.competitionGenderTypeId !== personState.person.competitionGenderTypeId) {

            setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });

          } else {

            setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState, personState, isSaved]);

  useEffect(() => {
    if (personState && Object.keys(personState).length > 0) {
      if (personState.person.competitionGenderTypeId === Constants.DEFAULT_ID) {
        if (formState.competitionGenderTypeId === Constants.DEFAULT_ID && isSaved === false) {

          setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState, personState, isSaved]);

  useEffect(() => {
    if (formState.competitionGenderTypeId && personState.person && competitionGenderState.isArrayLoaded === true) {

      const competitionGenderId = personState?.person?.competitionGenderTypeId > 0
        ? personState?.person?.competitionGenderTypeId
        : Constants.DEFAULT_ID

      const competitionGenderType = competitionGenderState?.arrayData?.find(x => x.competitionGenderTypeId === personState?.person?.competitionGenderTypeId);
      const competitionGenderTypeDisplayName = competitionGenderType?.displayName || '';
      const competitionGenderTypeName = competitionGenderType?.typeName || '';

      const newFormState = {
        ...formState,
        competitionGenderTypeId: competitionGenderId,
        competitionGenderTypeDisplayName: competitionGenderTypeDisplayName,
        competitionGenderTypeName: competitionGenderTypeName
      };

      setFormData(newFormState, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personState, competitionGenderState.isArrayLoaded]);

  useDidMountEffect(() => {
    if (isSaved === true) {

      setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
      //navigate(NavLinks.DISABILITIES_ATHLETE_U16);
      document.getElementById('omrHeadingId')?.scrollIntoView();
      navigate(NavLinks.NCSA_OPT_IN, { state: { fromGenderPage: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaved]);

  const onBackButtonClicked = (e) => {
    e?.preventDefault();
    document.getElementById('omrHeadingId')?.scrollIntoView();
    const navLink = personState?.is16orOlder === true
      ? NavLinks.ETHNICITY_16_AND_UP
      : NavLinks.ETHNICITY_U16;

    navigate(navLink);
  };

  return {
    personState,
    formState,
    errorState,
    setFormData,
    handleSubmit,
    onBackButtonClicked,
    onNextButtonClicked: handleSubmit,
    onFormValueChanged,
    isCompetitionCategoryLocked: state?.isCompetitionCategoryLocked
  };
};

export default useCompetitonCategoryAthU16;